import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { throwIfError } from '../../../../../lib/reserviceErrorHelpers'
import { getCustomError, getNormalizedUrl } from '../helpers'
import useCloneRequestController from './useCloneRequestController'

const EXTERNAL_URL_FETCH_TIMEOUT_MS = 5000

/**
 * Fetches external URL and returns HTML text. Throws on fetch error.
 * @returns {{ fetchHtml: (url: string, options?: { causeCode: string, timeoutMs?: number }) => Promise<string> }}
 */
const useExternalHtml = () => {
  const { fetchWithAbort, getIsHookError } = useCloneRequestController()

  const fetchHtml = async (url = '', { causeCode, timeoutMs = EXTERNAL_URL_FETCH_TIMEOUT_MS } = {}) => {
    const normalizedUrl = getNormalizedUrl(url)
    const [fetchError, response] = await safeAwait(
      fetchWithAbort(normalizedUrl, {}, timeoutMs)
    )
    if (fetchError) {
      const httpError = getIsHookError(fetchError)
        ? fetchError
        : getCustomError(causeCode, fetchError)
      throwIfError({ httpError })
    }

    return response.text()
  }

  return { fetchHtml }
}

export default useExternalHtml
